import tableService from '../request/service/table-service'

export default {
    data() {
        return {
            tableDataMixin: [],
            queryMixin: {
                pageSize: 10,
                pageNum: 1,
            },
            totalDataMixin: 0,
            tableLoadingMixin: false
        }
    },
    created() {
        let query = this.$route.query;
        this.queryMixin.pageNum = +(query.pageNum || 1);
        this.queryMixin.pageSize = +(query.pageSize || 10);
    },
    methods: {
        getDataMixin() {
            if (!this.tableOptions.url) {
                console.warn('请在tableOptions中填写url值');
                return;
            }
            this.tableLoadingMixin = true;
            return tableService.getTableList(this.tableOptions.url, Object.assign(this.queryMixin, this.tableOptions.params)).then((data) => {
                this.tableDataMixin = data.list;
                this.totalDataMixin = data.total;
                return data;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.tableLoadingMixin = false;
            });
        },
        handleSizeChangeMixin(size) {
            this.queryMixin.pageSize = size;
            let path = this.$route.path;
            this.$router.push({path, query: this.queryMixin});
            this.getDataMixin();
        },
        handleCurrentChangeMixin(page) {
            this.queryMixin.pageNum = page;
            let path = this.$route.path;
            this.$router.push({path, query: this.query});
            this.getDataMixin();
        },
    },
}